import './CTUS.scss';

import { PageManager } from 'genesis-packages/core';

export default class CTUS extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		const ctusForm = document.getElementById('js-form--ctus_form');
		if (ctusForm) {
			ctusForm.addEventListener('submit', (e) => this.ctusFormSubmit(e, ctusForm));
		}

	}

	async ctusFormSubmit (e, form) {
		if (window.grecaptcha) {
			e.preventDefault();
			await window.grecaptcha.execute('6Lds7CAaAAAAAG53S9JauGJy5JSqSY02rq41X2dI', {action: 'submit'}).then(function (token) {
				document.getElementById('g-recaptcha-response').value = token;
				form.submit();
			});
		}
	}

};
